import { render, staticRenderFns } from "./EditFileRequirement.vue?vue&type=template&id=07d047e5&scoped=true&"
import script from "./EditFileRequirement.vue?vue&type=script&lang=js&"
export * from "./EditFileRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d047e5",
  null
  
)

export default component.exports